export default __webpack_public_path__ + "static/media/vector-art-3.19c9db40.png";